import { createContext, useContext } from "react";
import type { PortalConfig } from "@/types/api";
import useMusioApi from "../client/musio-client-context";

// WARN: This is dependent on useMusioApi context

interface PortalConfigContextType extends PortalConfig { }

const PortalConfigContext = createContext<PortalConfigContextType | null>(null);

export function PortalConfigProvider({ children }: { children: React.ReactNode }) {
  const { musioApi } = useMusioApi();
  const { data: config } = musioApi.useQuery("get", "/portal-config", {}, { retry: 1 });

  return (
    <PortalConfigContext.Provider value={config ?? null}>
      {children}
    </PortalConfigContext.Provider>
  );
}

export const usePortalConfig = () => {
  return useContext(PortalConfigContext);
}

export default usePortalConfig;
